import { ComponentGroup } from '../types.js'

const iconContainer = new URL('../../../icons/components/container.png', import.meta.url).href
const popup = new URL('../../../icons/components/popup.png', import.meta.url).href

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:{{strokeColor}};}
    .st3{fill:none;stroke:{{strokeColor}};stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}
    .st9{fill:none;stroke:{{strokeColor}};stroke-miterlimit:10;}
  </style>
  <g>
    <rect x="2.8" y="10.3" class="st9" width="24.4" height="13.8"/>
    <polygon class="st0" points="27.7,9.8 2.3,9.8 7.8,5.9 22.2,5.9"/>
    <line class="st3" x1="10.9" y1="15.5" x2="19.1" y2="15.5"/>
  </g>
</svg>
`

export const container: ComponentGroup = {
  name: 'container',
  description: 'a group of various containers',
  icon,
  templates: [
    {
      type: 'container',
      description: 'general container',
      icon: iconContainer,
      group: 'container',
      model: {
        type: 'container',
        left: 100,
        top: 100,
        width: 100,
        height: 100,
        fillStyle: '#fff',
        strokeStyle: '#999',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    },
    {
      type: 'popup',
      description: 'popup window',
      icon: popup,
      group: 'container',
      model: {
        type: 'popup',
        left: 100,
        top: 100,
        width: 100,
        height: 100,
        fillStyle: '#fff',
        strokeStyle: 'DarkGoldenRod',
        hidden: true
      }
    }
  ]
}
